const Ach = [
  {
    year: '2020',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'Best Social Impact Creating SME of the year',
    organisation: 'SBI General and Times Now',
  },

  {
    year: '2020',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'Best SME in Infrastructure & Rean Estate for year',
    organisation: 'SBI General and Times Now',
  },

  {
    year: '2020',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'Emerging Company of the Year',
    organisation: 'ET Now Business Leader of the Year',
  },

  {
    year: '2019',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'HR Excellence Award',
    organisation: '',
  },

  {
    year: '2018',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'West Bengal Water Leadership Award',
    organisation: 'West Bengal Water Leadership Award',
  },

  {
    year: '2018',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title:
      'Indian Water & Waste Water Management Entrepreneurial Company of the year',
    organisation: 'Frost & Sullivan',
  },

  {
    year: '2018',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'India SME 100 Awards',
    organisation: 'India SME 100',
  },

  {
    year: '2017',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'India SME 100 Awards',
    organisation: 'India SME 100',
  },
]

export default Ach
